import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { LOCAL_STORAGE_KEYS, PanAppState } from '@panamax/app-state';
import { ModalController } from '@ionic/angular';
import { MessageTypeEnum } from '../../../ngrx-message/constants/messageTypeEnum';
import { SimpleActionModalComponent } from '../../../shared/components/simple-action-modal/simple-action-modal.component';
import { ToastService } from '../../../shared/services/toast/toast.service';
import { PATHS } from '../../../shared/constants/paths';
import { Subscription } from 'rxjs';
import { ProfileAnalyticsService } from '@app/profile/analytics/profile-analytics.service';
@Component({
  selector: 'app-profile-clear-data-card',
  templateUrl: './profile-clear-data-card.component.html',
  styleUrls: ['./profile-clear-data-card.component.scss'],
})
export class ProfileClearDataCardComponent implements OnInit, OnDestroy {
  @Input() isMobile: boolean;
  text: string;
  promptTitle: string;
  promptText: string;
  wipeStorageSub$: Subscription;

  constructor(
    private translateService: TranslateService,
    private modalCtrl: ModalController,
    private panAppState: PanAppState,
    private toastService: ToastService,
    private profileAnalyticsService: ProfileAnalyticsService,
  ) {}

  ngOnInit() {
    this.text = this.translateService.instant(
      'i18n.profilePage.clearData.text',
      {
        value: '<br/>',
      },
    );
    this.promptTitle = this.translateService.instant(
      'i18n.profilePage.clearData.title',
    );
    this.promptText = this.translateService.instant(
      'i18n.profilePage.clearData.modalText',
      {
        value: '. ',
      },
    );
  }

  ngOnDestroy() {
    if (this.wipeStorageSub$) {
      this.wipeStorageSub$.unsubscribe();
    }
  }

  async confirmClearAppData() {
    const modal = await this.modalCtrl.create({
      component: SimpleActionModalComponent,
      componentProps: {
        title: this.promptTitle,
        content: this.promptText,
        leftButtonText: 'i18n.common.cancel',
        rightButtonText: 'i18n.common.continue',
        note: null,
        exitButtonForTablet: true,
      },
      cssClass: this.isMobile ? 'ion-modal-touch' : 'simple-action-modal',
      mode: 'ios',
      initialBreakpoint: this.isMobile ? 1 : undefined,
      breakpoints: this.isMobile ? [0, 1] : undefined,
    });

    modal.onDidDismiss().then((response: any) => {
      if (response?.data?.dispatchAction) {
        this.panAppState.user$.pipe(take(1)).subscribe(user => {
          this.profileAnalyticsService.clearAppData(user?.ecomUserId);
        });
        this.profileAnalyticsService.clearAppDataTracking();
        this.clearAppData();
      }
    });
    return await modal.present();
  }

  routeTo(path: string) {
    window.location.assign(path);
  }

  clearAppData() {
    this.wipeStorageSub$ = this.panAppState
      .wipeStorage()
      .pipe(take(1))
      .subscribe(done => {
        if (done) {
          localStorage.setItem(
            LOCAL_STORAGE_KEYS.cacheCleared,
            JSON.stringify(true),
          );
          this.panAppState.user$.pipe(take(1)).subscribe(user => {
            this.profileAnalyticsService.clearAppDataSuccess(user?.ecomUserId);
          });
          this.routeTo(PATHS.HOME);
        } else {
          this.toastService.presentToastMsg(
            this.translateService.instant('i18n.profilePage.clearData.error'),
            'red-toast',
            MessageTypeEnum.error,
            [],
          );
        }
      });
  }
}
